import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClusterResultPage from '../../../ClusterResultPage';

function ResolveModal({ open, onClose, onSubmit, groupId, nodeId }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          height: '80vh',
          position: 'relative',
        },
      }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Resolve Record
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <ClusterResultPage issueGroupId={groupId} prevNodeId={nodeId} />
      </DialogContent>
    </Dialog>
  );
}

export default ResolveModal;
